import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Download } from '@mui/icons-material';
import {
  getDocumentDisplayName,
  getReceivingDocumentTypeLabel
} from '../../utils/storeCertificateDocuments';

const CertificateField = ({
  certificateNumber,
  document: certDoc,
  documents,
  onDownload,
  onDownloadDocument,
  downloading = false,
  downloadingDocId = '',
  size = 'small'
}) => {
  const docs = Array.isArray(documents) && documents.length
    ? documents
    : (certDoc ? [certDoc] : []);
  const hasMultiDownload = typeof onDownloadDocument === 'function';
  const hasSingleDownload = Boolean(onDownload);
  const numberLabel = certificateNumber || (docs.length ? 'On file' : '—');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 100 }}>
      <Typography variant="body2">
        {numberLabel}
      </Typography>
      {docs.map((doc) => {
        const fileName = getDocumentDisplayName(doc);
        const typeLabel = getReceivingDocumentTypeLabel(doc?.category);
        const downloadHandler = hasMultiDownload
          ? () => onDownloadDocument(doc)
          : (hasSingleDownload && docs.length === 1 ? onDownload : null);
        return (
          <Box key={doc?._id || fileName} sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
            {fileName && (
              <Typography variant="caption" color="text.secondary" noWrap title={`${typeLabel}: ${fileName}`}>
                {docs.length > 1 ? `${typeLabel}: ${fileName}` : fileName}
              </Typography>
            )}
            {downloadHandler && (
              <Button
                size={size}
                variant="outlined"
                startIcon={<Download />}
                onClick={(event) => {
                  event.stopPropagation();
                  downloadHandler();
                }}
                disabled={downloading || (doc?._id && downloadingDocId === String(doc._id))}
                sx={{ alignSelf: 'flex-start' }}
              >
                Download
              </Button>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default CertificateField;
